import UnifiedTimeline from "../../shared/Timeline/UnifiedTimeline";

/** @deprecated Use UnifiedTimeline. Thin wrapper for real-estate staff requests. */
export default function ServiceRequestTimeline({ entries = [] }) {
  return <UnifiedTimeline items={entries} showActor emptyMessage="No timeline entries yet." />;
}
